<template>
  <footer id="footer" :class="loginStatus['prodInst'] !== '1' ? 'main-color text-light text-center p-3' : 'prod-inst-color text-light text-center p-3'">
    <span>{{this.config.copyright}}</span>
  </footer>
</template>
<script>
export default {
  name: 'FloristFooter',
  data () {
    return {
      loginStatus: ''
    }
  },
  mounted () {
    // GETパラメータにprojectNumberとpasswordがあるとき、ログイン前として処理する
    if ('projectNumber' in this.$route.query && 'password' in this.$route.query) {
      this.loginStatus = {
        'beforeLogin': '1',
        'afterMTG': 'afterMTG' in this.$route.query ? this.$route.query.afterMTG : '0',
        'prodInst': 'prodInst' in this.$route.query ? this.$route.query.prodInst : '0'
      }
    } else {
      this.loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
      if (!this.loginStatus) {
        this.loginStatus = {
          'beforeLogin': '0',
          'afterMTG': 'afterMTG' in this.$route.query ? this.$route.query.afterMTG : '0',
          'prodInst': 'prodInst' in this.$route.query ? this.$route.query.prodInst : '0'
        }
      }
    }
  }
}
</script>
